<div class="item">
    <div class="pb-2">
        <mat-checkbox
            (change)='TranscriptArtifactChecked()' 
            [disabled]="artifact.locked" 
            [(ngModel)]="artifact.sectionValid"
        >{{ artifact.description || 'I will request my transcripts to be sent to ALSDE' }}</mat-checkbox>
    </div>
</div>